import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_AMOUNT_2,
	STR_AVAILABLE_HOTELS,
	STR_BACK,
	STR_CASH,
	STR_CHANGE_PHONE_NUMBER,
	STR_CLOSING_BALANCE,
	STR_COMMISSIONS_REPORT,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_CREATE_REPORT,
	STR_DESCRIPTON,
	STR_FLOAT,
	STR_INVALID_AGENT_TILLS,
	STR_INVALID_AMOUNT,
	STR_INVALID_DATE,
	STR_INVALID_REPORT,
	STR_INVALID_SERVICE_PROVIDER,
	STR_MENU_HOTELS,
	STR_NAME_OR_COMPANY,
	STR_NET_TOTAL,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_OPENING_BALANCE,
	STR_OPTIONAL,
	STR_PAYABLE,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_PHOTO_EVIDENCE,
	STR_RECEIVABLE,
	STR_RECENT_REQUESTS,
	STR_REPORT_DATE,
	STR_REPORT_FOR,
	STR_REPORT_TYPE,
	STR_REQUEST_AMOUNT_LIMIT,
	STR_REQUEST_FLOAT,
	STR_REQUEST_FLOAT_CASH,
	STR_SELECT,
	STR_SELECT_2,
	STR_SELECT_REQUEST_TYPE,
	STR_SERVICE_PROVIDER,
	STR_SUB_TOTAL,
	STR_SUBMIT,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_SUCCESS,
	STR_TILL_NUMBER,
	STR_TOTAL_2,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdAdd, MdCheckCircle, MdContactPage, MdDelete, MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import login_bg from '../assets/login_bg.jpg';
import HomeMenu from "./HomeMenu";
import WelcomeSlider from '../ones/WelcomeSlider';
import EditAgentProfile from "./EditAgentProfile";
import OpSuccessWidget from "../ones/OpSuccessWidget";

export default function View(props) {

	const appContext = useContext(AppContext);

	const currentDateTime = new Date();
  currentDateTime.setHours(currentDateTime.getHours() + 3);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	//const [reportType, setReportType] = useState('closing_balance');
	const [totalAmount, setTotalAmount] = useState(0);
	//const [reportBody, setReportBody] = useState(getInitialReportBody());
	const [dateReported, setDateReported] = useState(currentDateTime.toISOString().slice(0, 16));
	const [photo1, setPhoto1] = useState(null);
	const [photo2, setPhoto2] = useState(null);
	const [photo3, setPhoto3] = useState(null);
	const [description, setDescription] = useState('');

	const [reportBody1, setReportBody1] = useState(getInitialReportBody('closing_balance'));
	const [reportBody2, setReportBody2] = useState(getInitialReportBody('commissions'));
	const [reportBody3, setReportBody3] = useState(getInitialReportBody('receivable'));
	const [reportBody4, setReportBody4] = useState(getInitialReportBody('payable'));
	const [totalAmount1, setTotalAmount1] = useState(0);
	const [totalAmount2, setTotalAmount2] = useState(0);
	const [totalAmount3, setTotalAmount3] = useState(0);
	const [totalAmount4, setTotalAmount4] = useState(0);

	const [userTills, setUserTills] = useState(null);
	
	const [opSuccessful, setOpSuccessful] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getCurrentUserData(),
		])
		setReady(true);
	}

	function getInitialReportBody(reportType) {
		/**
		 * reportBody1 === closing balance report
		 * reportBody2 === commision report
		 * reportBody3 === receivables report
		 * reportBody4 === payables report
		 */
		if(appContext.currentUserData) {
			const agentTills = JSON.parse(appContext.currentUserData.agentTills);

			if(agentTills && agentTills.length > 0) {
				if(
					reportType === 'closing_balance' 
				) {
					for (let i = 0; i < agentTills.length; i++) {
						const till = agentTills[i];
						till.amount = 0;
					}

					//add cash field
					agentTills.push({
						tillType: "cash",
						tillNumber: "",
						tillName: appContext.currentUserData.agentTillName,
						amount: 0,
					});
				} else if(reportType === 'commissions') {
					for (let i = 0; i < agentTills.length; i++) {
						const till = agentTills[i];
						till.amount = 0;
					}
					
				} else if(
					reportType === 'payable' ||
					reportType === 'receivable'
				) {
				
					//add just an object with name and amount
					//this is custom report, not like others
					const customReportBody = [];

					customReportBody.push({
						name: "",
						amount: 0,
					});

					return customReportBody;
				}
			}

			return agentTills;
		}

		return null;
	}

	function handleReportBodyAmountChange(index, value, setter) {
		setter(_prev => {
			const _new = [..._prev];

			_new[index].amount = (Number(value) || 0);

			return _new;
		})
	}

	function handleCustomReportBodyNameChange(index, value, setter) {
		setter(_prev => {
			const _new = [..._prev];

			_new[index].name = value;

			return _new;
		})
	}

	function addItemToCustomReportBody(setter) {
		setter(_prev => {
			const _new = [..._prev];

			_new.push({
				name: "",
				amount: 0,
			});

			return _new;
		})
	}

	function deleteItemFromCustomReportBody(index, setter) {
		setter(_prev => {
			const _new = [..._prev];

			_new.splice(index, 1);

			return _new;
		})
	}

	
	function getTotalAmount() {
		let _total = 0;

		if(Number(totalAmount1) && !isNaN(Number(totalAmount1))) {
			_total += Number(totalAmount1); //add up closing_balances
		}

		if(Number(totalAmount2) && !isNaN(Number(totalAmount2))) {
			_total += Number(totalAmount2); //add up commissions
		}

		if(Number(totalAmount3) && !isNaN(Number(totalAmount3))) {
			_total += Number(totalAmount3); //add up receivables
		}

		if(Number(totalAmount4) && !isNaN(Number(totalAmount4))) {
			_total -= Number(totalAmount4); //substract payables
		}

		return _total;
	}
	
	
	function getTotalAmount1() {
		let _total = 0;

		if(reportBody1) {
			for (const item of reportBody1) {
				_total += Number(item.amount);
			}
		}

		return _total;
	}

	function getTotalAmount2() {
		let _total = 0;

		if(reportBody2) {
			for (const item of reportBody2) {
				_total += Number(item.amount);
			}
		}

		return _total;
	}

	function getTotalAmount3() {
		let _total = 0;

		if(reportBody3) {
			for (const item of reportBody3) {
				_total += Number(item.amount);
			}
		}

		return _total;
	}

	function getTotalAmount4() {
		let _total = 0;

		if(reportBody4) {
			for (const item of reportBody4) {
				_total += Number(item.amount);
			}
		}

		return _total;
	}

	async function submit() {
		const _photo1 = document.getElementById('_photo1').files[0];
		const _photo2 = document.getElementById('_photo2').files[0];
		const _photo3 = document.getElementById('_photo3').files[0];

		if(reportBody1 && reportBody2 && reportBody3 && reportBody4) {
			if(dateReported.trim().length > 0) {
				
				setLoading(true);
				await callApi(
					'create-agent-report',
					{
						totalAmount,
						totalAmount1,
						totalAmount2,
						totalAmount3,
						totalAmount4,
						dateReported,
						reportBody1: JSON.stringify(reportBody1),
						reportBody2: JSON.stringify(reportBody2),
						reportBody3: JSON.stringify(reportBody3),
						reportBody4: JSON.stringify(reportBody4),
						photo1: (_photo1 || ''),
						photo2: (_photo2 || ''),
						photo3: (_photo3 || ''),
						description,
					}
				).then((response) => {
					if(response.status === 1) {
						appContext.getMyAgentReports();
						setOpSuccessful(true);
					} else {
						appContext.tellError(response.msg);
					}
				})
				setLoading(false);
				
			} else {
				appContext.tellError(STR_INVALID_DATE[appContext.language]);
			}
		} else {
			appContext.tellError(STR_INVALID_REPORT[appContext.language]);
		}
	}


	useEffect(() => {
		init();
	}, [])

	/*
	useEffect(() => {
		setReportBody(getInitialReportBody());
	}, [ reportType ])
	*/

	/*
	useEffect(() => {
		setTotalAmount(getTotalAmount());
	}, [ reportBody ])
	*/

	useEffect(() => {
		setTotalAmount1(getTotalAmount1());
	}, [ reportBody1 ])

	useEffect(() => {
		setTotalAmount2(getTotalAmount2());
	}, [ reportBody2 ])

	useEffect(() => {
		setTotalAmount3(getTotalAmount3());
	}, [ reportBody3 ])

	useEffect(() => {
		setTotalAmount4(getTotalAmount4());
	}, [ reportBody4 ])

	useEffect(() => {
		setTotalAmount(getTotalAmount());
	}, [ totalAmount1, totalAmount2, totalAmount3, totalAmount4 ]);

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	useEffect(() => {
		if(appContext.currentUserData) {
			setUserTills(JSON.parse(appContext.currentUserData.agentTills));
		}
	}, [ appContext.currentUserData ])

	if (ready) {
		if(appContext.isAgentProfileComplete) {
			return (
				<div
					style={{
						width: "100%",
						height: "100%",
						overflow: "scroll",
						paddingBottom: "calc(var(--topBarHeight) + 40px)",
					}}
					className="mNoScrollBar"
				>
					<div className="container">
	
						<div className="row">
	
							<div className="col-md-12">
								<h6
									className="mSectionTitle"
								>
									{STR_CREATE_REPORT[appContext.language]}
								</h6>
							</div>

							{
								(opSuccessful) ?
								<div 
									className="col-md-12"
								>
									<OpSuccessWidget/>
								</div>
								:
								<div 
									className="col-md-12"
								>
									<div className="mt-4 mb-4">
										<label className="form-label">{STR_REPORT_DATE[appContext.language]}</label>
										<input
											className="form-control"
											value={dateReported}
											type="datetime-local"
											onChange={e => setDateReported(e.target.value)}
										/>
									</div>


									<div className="mt-4 mb-4">
										{
										/*
											
										<label className="form-label">{STR_REPORT_TYPE[appContext.language]}</label>
										<div className="row">
											
											{
												['commissions', 'closing_balance', 'receivable', 'payable'].map((item, i) => {
													return (
														<div className="col-6 mb-2" key={i}>
															<button
																className={(reportType === item) ? "btn btn-secondary" : "btn btn-outline-secondary"}
																style={{
																	width: "100%",
																	height: "70px",
																	paddingTop: "10px",
																	paddingBottom: "10px",
																	fontSize: "14px",
																	fontFamily: "FontBold",
																}}
																onClick={() => setReportType(item)}
															>
																{(item === 'closing_balance') ? STR_CLOSING_BALANCE[appContext.language] : ""}
																{(item === 'commissions') ? STR_COMMISSIONS_REPORT[appContext.language] : ""}
																{(item === 'receivable') ? STR_RECEIVABLE[appContext.language] : ""}
																{(item === 'payable') ? STR_PAYABLE[appContext.language] : ""}
															</button>
														</div>
													)
												})
											}

											
										</div>
										*/
										}
									</div>

									<div className="mt-4 mb-4">
										{
										/**
											 
											 
										{
											(reportBody) ?
											reportBody.map((item, i) => {
												if(reportType === 'payable' || reportType === 'receivable') {
													//..
													return (
														<div
															key={i}
															style={{
																borderBottom: "1px solid black",
																paddingBottom: "5px",
																paddingTop: "5px"
															}}
														>
															<div className="row">
																
																<div className="col-6">
																	<input
																		className="form-control"
																		value={item.name || ''}
																		onChange={(e) => {
																			handleCustomReportBodyNameChange(i, e.target.value)
																		}}
																		placeholder={STR_NAME_OR_COMPANY[appContext.language]}
																	/>
																</div>

																<div className="col-5">
																	<input
																		className="form-control"
																		value={item.amount}
																		onChange={(e) => {
																			handleReportBodyAmountChange(i, e.target.value)
																		}}
																	/>
																</div>

																<div className="col-1" style={{ padding: "0" }}>
																	<MdDelete
																		onClick={() => {
																			deleteItemFromCustomReportBody(i)
																		}}
																		className="text-danger"
																		size={24}
																	/>
																</div>

															</div>
														</div>
													)
													//..
												} else {
													//..
													return (
														<div
															key={i}
															style={{
																borderBottom: "1px solid black",
																paddingBottom: "5px",
																paddingTop: "5px"
															}}
														>
															<div className="row">
																<div className="col-6">
																	<h6
																		style={{
																			fontSize: "14px"
																		}}
																		className="font-semi-bold"
																	>
																		{
																			(item.tillType === 'cash') ? STR_CASH[appContext.language] : appContext.getTillTypeName(item.tillType)
																		}
																		<br/>
																		<span className="text-muted">{item.tillNumber}</span>
																	</h6>
																</div>

																<div className="col-6">
																	<input
																		className="form-control"
																		value={item.amount}
																		onChange={(e) => {
																			handleReportBodyAmountChange(i, e.target.value)
																		}}
																	/>
																</div>
															</div>
														</div>
													)
													//..
												}
											})
											:""
										}

										{
											(reportType === 'payable' || reportType === 'receivable') ?
											<div className="text-end">
												<button
													className="btn btn-outline-dark btn-sm"
													onClick={addItemToCustomReportBody}
												>
													<MdAdd size={24}/>
												</button>
											</div>
											:""
										}
										*/
										}
									</div>

									<div className="mt-4 mb-4">
										<div className="card">
											<div className="card-body">

												<h6 className="card-title">{STR_CLOSING_BALANCE[appContext.language]}</h6>
												<hr/>

												{
													(reportBody1) ?
													reportBody1.map((item, i) => {
														
														return (
															<div
																key={i}
																style={{
																	borderBottom: "1px solid black",
																	paddingBottom: "5px",
																	paddingTop: "5px"
																}}
															>
																<div className="row">
																	<div className="col-6">
																		<h6
																			style={{
																				fontSize: "14px"
																			}}
																			className="font-semi-bold"
																		>
																			{
																				(item.tillType === 'cash') ? STR_CASH[appContext.language] : appContext.getTillTypeName(item.tillType)
																			}
																			<br/>
																			<span className="text-muted">{item.tillNumber}</span>
																		</h6>
																	</div>

																	<div className="col-6">
																		<input
																			className="form-control"
																			value={item.amount}
																			onChange={(e) => {
																				handleReportBodyAmountChange(i, e.target.value, setReportBody1)
																			}}
																		/>
																	</div>
																</div>
															</div>
														)
															
													})
													:""
												}

												<hr/>
												<h6 
													className="font-semi-bold"
													style={{
														fontSize: "18px"
													}}
												>
													<span className="d-block font-semi-bold" style={{ fontSize: "14px" }} >{STR_SUB_TOTAL[appContext.language]}</span>
													{formatMoney(totalAmount1)} TZS
												</h6>

											</div>
										</div>
										
									</div>

									<div className="mt-4 mb-4">
										<div className="card">
											<div className="card-body">
												<h6 className="card-title">{STR_COMMISSIONS_REPORT[appContext.language]}</h6>
												<hr/>

												{
													(reportBody2) ?
													reportBody2.map((item, i) => {
														
														//..
														return (
															<div
																key={i}
																style={{
																	borderBottom: "1px solid black",
																	paddingBottom: "5px",
																	paddingTop: "5px"
																}}
															>
																<div className="row">
																	<div className="col-6">
																		<h6
																			style={{
																				fontSize: "14px"
																			}}
																			className="font-semi-bold"
																		>
																			{
																				(item.tillType === 'cash') ? STR_CASH[appContext.language] : appContext.getTillTypeName(item.tillType)
																			}
																			<br/>
																			<span className="text-muted">{item.tillNumber}</span>
																		</h6>
																	</div>

																	<div className="col-6">
																		<input
																			className="form-control"
																			value={item.amount}
																			onChange={(e) => {
																				handleReportBodyAmountChange(i, e.target.value, setReportBody2)
																			}}
																		/>
																	</div>
																</div>
															</div>
														)
														//..
														
													})
													:""
												}

												<hr/>
												<h6 
													className="font-semi-bold"
													style={{
														fontSize: "18px"
													}}
												>
													<span className="d-block font-semi-bold" style={{ fontSize: "14px" }} >{STR_SUB_TOTAL[appContext.language]}</span>
													{formatMoney(totalAmount2)} TZS
												</h6>
											</div>
										</div>
										
									</div>

									<div className="mt-4 mb-4">

										<div className="card">
											<div className="card-body">
												<h6 className="card-title">{STR_RECEIVABLE[appContext.language]}</h6>
												<hr/>

												{
													(reportBody3) ?
													reportBody3.map((item, i) => {
														
														return (
															<div
																key={i}
																style={{
																	borderBottom: "1px solid black",
																	paddingBottom: "5px",
																	paddingTop: "5px"
																}}
															>
																<div className="row">
																	
																	<div className="col-6">
																		<input
																			className="form-control"
																			value={item.name || ''}
																			onChange={(e) => {
																				handleCustomReportBodyNameChange(i, e.target.value, setReportBody3)
																			}}
																			placeholder={STR_NAME_OR_COMPANY[appContext.language]}
																		/>
																	</div>

																	<div className="col-5">
																		<input
																			className="form-control"
																			value={item.amount}
																			onChange={(e) => {
																				handleReportBodyAmountChange(i, e.target.value, setReportBody3)
																			}}
																		/>
																	</div>

																	<div className="col-1" style={{ padding: "0" }}>
																		<MdDelete
																			onClick={() => {
																				deleteItemFromCustomReportBody(i, setReportBody3)
																			}}
																			className="text-danger"
																			size={24}
																		/>
																	</div>

																</div>
															</div>
														)
															
													})
													:""
												}

												
												<div className="text-end">
													<button
														className="btn btn-outline-dark btn-sm"
														onClick={() => addItemToCustomReportBody(setReportBody3)}
													>
														<MdAdd size={24}/>
													</button>
												</div>

												<hr/>
												<h6 
													className="font-semi-bold"
													style={{
														fontSize: "18px"
													}}
												>
													<span className="d-block font-semi-bold" style={{ fontSize: "14px" }} >{STR_SUB_TOTAL[appContext.language]}</span>
													{formatMoney(totalAmount3)} TZS
												</h6>
											</div>
										</div>
											
									</div>


									<div className="mt-4 mb-4">
										<div className="card">
											<div className="card-body">

												<h6 className="card-title">{STR_PAYABLE[appContext.language]}</h6>
												<hr/>

												{
													(reportBody4) ?
													reportBody4.map((item, i) => {
														//..
														return (
															<div
																key={i}
																style={{
																	borderBottom: "1px solid black",
																	paddingBottom: "5px",
																	paddingTop: "5px"
																}}
															>
																<div className="row">
																	
																	<div className="col-6">
																		<input
																			className="form-control"
																			value={item.name || ''}
																			onChange={(e) => {
																				handleCustomReportBodyNameChange(i, e.target.value, setReportBody4)
																			}}
																			placeholder={STR_NAME_OR_COMPANY[appContext.language]}
																		/>
																	</div>

																	<div className="col-5">
																		<input
																			className="form-control"
																			value={item.amount}
																			onChange={(e) => {
																				handleReportBodyAmountChange(i, e.target.value, setReportBody4)
																			}}
																		/>
																	</div>

																	<div className="col-1" style={{ padding: "0" }}>
																		<MdDelete
																			onClick={() => {
																				deleteItemFromCustomReportBody(i, setReportBody4)
																			}}
																			className="text-danger"
																			size={24}
																		/>
																	</div>

																</div>
															</div>
														)
															
													})
													:""
												}

												
												<div className="text-end">
													<button
														className="btn btn-outline-dark btn-sm"
														onClick={() => addItemToCustomReportBody(setReportBody4)}
													>
														<MdAdd size={24}/>
													</button>
												</div>

												<hr/>
												<h6 
													className="font-semi-bold"
													style={{
														fontSize: "18px"
													}}
												>
													<span className="d-block font-semi-bold" style={{ fontSize: "14px" }} >{STR_SUB_TOTAL[appContext.language]}</span>
													{formatMoney(totalAmount4)} TZS
												</h6>
											</div>
										</div>
									</div>

									<div className="mt-4 mb-4">
										<label className="form-label">{STR_NET_TOTAL[appContext.language]}</label>
										<input
											className="form-control font-bold"
											value={totalAmount}
											onChange={(e) => setTotalAmount(e.target.value)}
											style={{
												fontSize: "36px"
											}}
											placeholder="eg 10000"
											readOnly
										/>
										
									</div>

									<div className="mt-4 mb-4">
										<label className="form-label">{STR_DESCRIPTON[appContext.language]}</label>
										<textarea
											className="form-control"
											value={description}
											onChange={(e) => setDescription(e.target.value)}
											
										/>
										<div className="form-text">
											{STR_OPTIONAL[appContext.language]}
										</div>
									</div>

									<div className="mt-4 mb-4">
										<label className="form-label">{STR_PHOTO_EVIDENCE[appContext.language]}</label>
										<input
											className="form-control mt-2"
											type="file"
											id='_photo1'
											accept="image/*"
										/>
										<input
											className="form-control mt-2"
											type="file"
											id='_photo2'
											accept="image/*"
										/>
										<input
											className="form-control mt-2"
											type="file"
											id='_photo3'
											accept="image/*"
										/>

										<div className="form-text">
											{STR_OPTIONAL[appContext.language]}
										</div>
									</div>

									<div className="mt-4 mb-4">
										<button
											className="btn btn-block btn-primary btn-padded btn-rounded"
											onClick={() => {
												appContext.activateDialog({
													message: STR_CREATE_REPORT[appContext.language],
													onConfirm: submit,
												})
											}}
										>
											{STR_SUBMIT[appContext.language]}
										</button>
									</div>

								</div>
							}
	
						</div>
	
						
	
					</div>
	
	
				</div>
			)
		} else {
			return <EditAgentProfile/>
		}
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}